export enum WorkspaceSidebarToken {
  Notifications = 'notifications',
}
